/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ion-content[_ngcontent-%COMP%]{--background:transparent}.promo-container[_ngcontent-%COMP%]{width:100%;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.promo-container[_ngcontent-%COMP%]   ion-img[_ngcontent-%COMP%]{border-radius:16px;cursor:pointer;overflow:hidden;width:500px;height:500px;max-width:80%;margin:auto}.popup-close[_ngcontent-%COMP%]{text-align:center;margin-bottom:15px;cursor:pointer}.popup-close[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:26px;color:#fff}"];
export { styles as styles };
